export default __webpack_public_path__ + "static/media/plus.983e1924.svg";